module.exports = __webpack_public_path__ + "img/img15.33e7392.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img15.png
// module id = 363
// module chunks = 0